export function loadBuildValidateAction(trigger){
    return async function(dispatch){
        const action = { type : 'IS_VALIDATED', payload : trigger}
        dispatch(action);
    }
}

